/*
 * @Author: maxwellllu
 * @Date: 2023-04-27 22:11:42
 * @LastEditors: maxwellllu
 * @LastEditTime: 2023-06-02 15:47:58
 * @FilePath: /privatization-webim/src/utils/api.ts
 * @Description:
 */
/**
 * @desc 请求接口
 */

export const commonConfig = '/webim/innerPage/getCommonConfig';

// 合回SAAS重构通用配置接口
export const COMMON_INFO_URL = '/v1/receptionConf/webim/getCommonInfo';

export const COMPANY_INFO_URL = '/v1/receptionConf/webim/getCompanyInfo';


// 留言表单或者验证码
export const SEND_CAPTCHA = '/v1/kf/reception/receptionConf/leaveMessage/customerSendCaptcha';
// 留言获取表单配置
export const GET_CUSTOMER_MESSAGE_CONFIG = '/v1/kf/reception/receptionConf/leaveMessage/customerMessageConfig';
// 留言表单提交
export const CREATE_CUSTOMER_MESSAGE = '/v1/receptionConf/leaveMessage/customerMessageCreate';
// 机器人上报
export const ROBOT_ANSWER_REPORT = '/log_processing/data_report/robot_answer_report';

// 加好友卡片信息
export const GET_ADD_FRIEND_SCHEME = '/tp/wpaCall/GetAddFriendProtocol';
// 跳转qq中间页
export const ROUTE_CHANGE_LOADING_QQ = '/template/blue/wpa/link.html';
// 获取跳转qq sign
export const GET_TENCENT_SCHEME = '/tp/wpaCall/getWebProtocol';
// 音视频行为 201，203，205，206
export const POST_VIDEO_CANCEL_REPORT = '/v1/rtc/action/report';
// 音视频小程序开放标签签名
export const VIDEO_WXSDK_SIGNATURE = '/v1/video/wxsdk/signature';
// 音视频小程序跳转urlscheme
export const VIDEO_MINIPROGRAM_URLSCHEME = '/v1/video/mini_program/urlscheme';
// 获取音视频会话配置信息
export const GET_MULTI_MEDIA_CONF = '/v1/im_wpa/get_multi_media_conf';

// 监测当前主号的webim版本
export const CHECK_IF_WEBIM_V3 = '/v1/interface/inner/cloudcc_303905';

// 机器人延迟回复配置信息
export const ROBOT_REPLAY_DELAY = '/robot/delayReply';

// 机器人电商结构化消息分页获取

export const ROBOT_BUSINESS_TEMPLATE_LIST = '/v1/customerService/robot/getRobotAPIStyleTemplateDataList';
// 电商悬浮卡片
export const GET_QUICK_ORDER_CARD = '/v1/commerce/c/item/get';

// 电商悬浮卡片
export const DISPLAY_MESSAGE_ON_C = '/v1/wpaVisitor/displayMessageOnC';

// 获取老webim漫游消息中的文件消息的COS下载地址
export const GET_FILE_DOWNLOAD_URL_FOR_OLD_MSG = '/v1/interface/inner/cloudcc_303206';

// 消息链路追踪
export const IM_MSG_TRACING_REPORT = '/im_msg_tracing_report';

// 获取广交会名片信息
export const SEND_BUSINESS_CARD = '/v1/cantonFair/SendC2BCard';

// 广交会获取结构化消息
export const GET_MSG_INFO_DATA =  '/v1/cantonFair/GetXmlMsgData';

// 切换语言
export const SWITCH_LANG =  '/v1/cantonFair/SwitchLanguage';

// 2d卡通数字人 文本转语音接口
export const GET_TTS = '/settings/CcXiaoWeiTTS';

// 真人数字人创建接口
export const CREATE_DIGITAL_HUMAN = '/receptionConf/digitalHuman/create';
// 真人数字人关闭接口
export const CLOSE_DIGITAL_HUMAN = '/receptionConf/digitalHuman/close';
// 真人数字人打断接口
export const INTERRUPT_DIGITAL_HUMAN = '/receptionConf/digitalHuman/interrupt';
// 机器人输入联想

export const ROBOT_AUTO_COMPLETE = '/v1/robot/auto/complete';

// 获取消息 已读回执 开关
export const GET_READ_REPORT_SWITCH = '/v1/receptionConf/webim/getCommonInfo';

// 咨询表单详情
export const GET_CONSULT_FORM_DETAIL = '/v1/form/im/detail';

// 提交咨询表单
export const SUBMIT_CONSULT_FORM = '/v1/form/im/report';

// 机器人导航 点击跳转网页 上报
export const REPORT_ROBOTNAV_URLCLICK = '/v1/robot/urlClickReport';
// 请求是否有询前表单
export const BEFORE_CONSULT_SEND = '/v1/form/im/send';

// 跳过询前表单
export const BEFORE_CONSULT_SKIP = '/v1/form/im/skip';
